import { useI18n } from 'hooks/useI18n';
import { useRouter } from 'next/router';
import {
  Bar,
  BarChart,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis
} from 'recharts';
import MethodologyAnchor from '../../shared/methodologyAnchor/MethodologyAnchor';
import { StyledRecharts } from '../../shared/recharts/Recharts.styled';
import { SOFTSKILLS } from '../Talent.constants';

const SoftSkillsCommunityVsOffered: React.FC = () => {
  const { t } = useI18n('developer-career-report-2023');
  const { locale } = useRouter();
  const softSkills = SOFTSKILLS(locale);

  return (
    <div>
      <StyledRecharts className="skills">
        <ResponsiveContainer width="99%" height={950} minWidth={500}>
          <BarChart data={softSkills} layout="vertical">
            <XAxis
              type="number"
              allowDecimals={false}
              tickLine={false}
              padding={{ left: 20 }}
              tickFormatter={(tick) => {
                return `${tick}%`;
              }}
            ></XAxis>
            <YAxis
              type="category"
              dataKey={(data) => data.skill[locale || 'en']}
              tickLine={false}
              width={200}
            />
            <Tooltip
              cursor={{ fill: '#ebe8df' }}
              labelStyle={{ display: 'none' }}
              separator=""
              formatter={(value: number) => [value.toFixed(1) + '%', '']}
              wrapperClassName="tooltip-y"
            />
            <Legend
              layout="horizontal"
              iconType="square"
              wrapperStyle={{ bottom: 0 }}
            />
            <Bar
              dataKey="offers"
              name={t('mandecar23.talent.competences.companies')}
              fill="#7EAFD3"
              barSize={8}
              radius={5}
            />
            <Bar
              dataKey="users"
              name={t('mandecar23.talent.competences.community')}
              fill="#8DD3C7"
              barSize={8}
              radius={5}
            />
          </BarChart>
        </ResponsiveContainer>
      </StyledRecharts>
      <MethodologyAnchor />
    </div>
  );
};

export default SoftSkillsCommunityVsOffered;
